import { NetworkType } from 'abis/set/sets'
import { useTheme } from 'hooks'
import React, { createContext, Provider, useContext, useState } from 'react'
import { BlockInfo } from 'services'
import { Nullable } from 'utils'
import { StoreProps, StoreProviderProps } from './interface'

export const [useStore, CtxProvider] = createCtx<StoreProps>()

export const StoreProvider: React.FC<StoreProviderProps> = ({ children }) => {
  const [connectionModal, setConnectionModal] = useState(false)
  const [network, setNetwork] = useState<Nullable<NetworkType>>(1)
  const [loadingNetwork, setLoadingNetwork] = useState(false)
  const [isNavOpen, setNavOpen] = useState<boolean>(false)
  const [showLegal, setShowLegal] = useState<boolean>(true)
  const [blockNumberInfo, setBlockNumberInfo] = useState<BlockInfo>({ data: { eth: [] } })
  //Hooks
  const [isDarkMode, setDarkMode] = useTheme()

  return (
    <CtxProvider
      value={{
        showLegal,
        setShowLegal,
        isDarkMode,
        isNavOpen,
        blockNumberInfo,
        connectionModal,
        loadingNetwork,
        setLoadingNetwork,
        network,
        setDarkMode,
        setNavOpen,
        setConnectionModal,
        setBlockNumberInfo,
        setNetwork,
      }}
    >
      {children}
    </CtxProvider>
  )
}

function createCtx<ContextType>(): [() => ContextType, Provider<ContextType>] {
  const ctx = createContext<ContextType>({} as ContextType)
  function useCtx() {
    const c = useContext(ctx)
    if (!c) {
      throw new Error('useCtx must be inside a Provider with a value')
    }
    return c
  }
  return [useCtx, ctx.Provider]
}
